/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { PublicMarketCountriesQuery } from '@gql/PublicMarketCountriesQuery'

export function useCountrySearch(cb: () => { enabled: boolean }) {
  const { ui: list, loading } = useApolloWrap2<gen.PublicMarketCountriesQuery, gen.PublicMarketCountriesQueryVariables>(PublicMarketCountriesQuery)({
    vars: () => (import.meta.browser && cb().enabled ? {} : undefined),
    ui: (i) => helpers.sortSimpleStr(i?.publicMarketCountries?.items, (i) => i.title.value || ''),
  })

  return {
    isLoading: toRef(() => loading.value),
    list,
    searchOn: (item: (typeof list)['value'][number]) => [item.title?.value, item.iso2, ...helpers.arr(item.altname)],
  }
}
